// Cookie consent utility
// Storage key for consent preference

const CONSENT_KEY = 'fl_cookie_consent';

export type ConsentStatus = 'accepted' | 'rejected' | 'unset';

/**
 * Safely check if we're in a browser environment
 */
const isBrowser = (): boolean => {
  return typeof window !== 'undefined' && typeof localStorage !== 'undefined';
};

/**
 * Get the current consent status from localStorage
 */
export const getConsent = (): ConsentStatus => {
  if (!isBrowser()) return 'unset';
  
  const stored = localStorage.getItem(CONSENT_KEY);
  if (stored === 'accepted' || stored === 'rejected') {
    return stored;
  }
  return 'unset';
};

/**
 * Set the consent status in localStorage
 */
export const setConsent = (status: 'accepted' | 'rejected'): void => {
  if (!isBrowser()) return;
  
  localStorage.setItem(CONSENT_KEY, status);
  
  // Dispatch a custom event so other components can react
  window.dispatchEvent(new CustomEvent('consentChanged', { detail: status }));
};

/**
 * Clear consent (for testing purposes)
 */
export const clearConsent = (): void => {
  if (!isBrowser()) return;
  localStorage.removeItem(CONSENT_KEY);
};

/**
 * Check if analytics should be loaded based on consent
 */
export const shouldLoadAnalytics = (): boolean => {
  return getConsent() === 'accepted';
};
